import script from "./Step5.vue?vue&type=script&setup=true&lang=js"
export * from "./Step5.vue?vue&type=script&setup=true&lang=js"

import "./Step5.vue?vue&type=style&index=0&id=b20fa888&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b20fa888"]])

export default __exports__